import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const resourceApi = createApi({
  reducerPath: 'resourceApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['resource'],
  endpoints: (builder) => ({
    getAllResource: builder.query({
      query: ({ pageno, search, type, sortOrder, sortBy ,disablePagination ,limit , category }) => {
        let url = `/admin/resources?pageno=${pageno}`;
        if (search) {
          url += `&search=${search}`;
        }
        if (type) {
          url += `&type=${type}`;
        }
        if (category) {
          url += `&category=${category}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }
        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }
        if(disablePagination){
          url += `&disablePagination=true`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['resource'],
    }),
    getSingleResource: builder.query({
      query: ({ id }) => {
        let url = `/admin/resource/${id}`;
        return { url, method: 'GET' };
      },
      providesTags: ['resource'],
    }),
    addResource: builder.mutation({
      query: (data) => ({
        url: `/admin/resource`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['resource'],
    }),
    updateResource: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/resource/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['resource'],
    }),
    updateResourceStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/resource/status/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['resource'],
    }),
    deleteResource: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/resource/${id}`,
        method: 'DELETE',
      }),
    }),
    toggleAssignUser: builder.mutation({
      query: ({ resourceId, userId }) => ({
        url: `/admin/resource/toggle/${resourceId}`,
        method: 'PUT',
        body: { userId },
      }),
      invalidatesTags: ['resource', 'users'],
    }),
    getResourceHome: builder.query({
      query: ({ pageno, search, category, fileType ,sortOrder, sortBy ,limit}) => {
        let url = `/contractor/resources?pageno=${pageno}`;
        if (search) {
          url += `&search=${search}`;
        }
        if (category) {
          url += `&category=${category}`;
        }
        if (fileType) {
          url += `&fileType=${fileType}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }
        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['resource'],
    }),
    getHomeResourceDetail: builder.query({
      query: ({ id }) => ({
        url: `/contractor/resource/${id}`,
        method: 'GET',
      }),
      providesTags: ['resource'],
    }),
    assignUsertoMultipleResources : builder.mutation({
      query: ({ resourceIds, packageIds, userId }) => ({
        url: `/admin/resources/assign`,
        method: 'PUT',
        body: { resourceIds, packageIds, userId },
      }),
      invalidatesTags: ['resource', 'users'],
    }),
    getUserResourceAssignment: builder.query({
      query: (userId) => ({
        url: `/admin/user/${userId}/resource-assignment`,
        method: 'GET',
      }),
      providesTags: ['resource'],
    }),
     reorderResources : builder.mutation({
      query: (data) => ({
        url: `/admin/resources/reorder`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['resource'],
    })


  }),
});

export const {
  useGetAllResourceQuery,
  useAddResourceMutation,
  useUpdateResourceMutation,
  useUpdateResourceStatusMutation,
  useGetSingleResourceQuery,
  useDeleteResourceMutation,
  useToggleAssignUserMutation,
  useGetResourceHomeQuery,
  useGetHomeResourceDetailQuery,
  useAssignUsertoMultipleResourcesMutation,
  useReorderResourcesMutation,
  useGetUserResourceAssignmentQuery
} = resourceApi;